import { BadgeCheck, Send, UserRound } from "lucide-react";

/* Composer used ONLY by the Virtual Guide — independent from the Chat with Us composer. Typing only: the voice flow never shows this box.
   The "I'm a participant" icon / verified badge mirrors Chat with Us exactly. */
export const VirtualGuideComposer = ({ cfg, t, input, setInput, onSend, busy, inReview, me, onVerify }) => {
  const side = (
    <>
      {!me && onVerify && <button type="button" data-testid="vg-verify-open" title={cfg.verify_button_text || "I'm a participant"} onClick={onVerify} className="grid place-items-center w-10 h-10 rounded-full border border-[#2F6B4F]/40 text-[#2F6B4F] bg-[#F3F8F4] shrink-0"><UserRound size={16} /></button>}
      {me && <span data-testid="vg-me-badge" title={me.name} className="flex flex-col items-center shrink-0 w-12 leading-none">
        <span className="relative grid place-items-center w-10 h-10 rounded-full border border-emerald-300 bg-emerald-50 text-emerald-800"><UserRound size={16} /><BadgeCheck size={12} className="absolute -bottom-0.5 -right-0.5 text-emerald-600 bg-white rounded-full" /></span>
        <span data-testid="vg-me-name" className={`mt-1 text-[10px] font-semibold truncate max-w-[3rem] ${t.muted}`}>{(me.name || "").split(" ")[0]}</span>
      </span>}
    </>
  );
  if (cfg.vg_text_input_show === false) {
    return (
      <div className={`border-t ${t.footer} px-3 py-2 flex items-center gap-2`}>
        <p data-testid="vg-text-hidden" className={`flex-1 text-center text-[11px] ${t.muted}`}>{me ? "Typing is switched off for the Virtual Guide — use the voice conversation." : "Verify you're in the current batch to talk with the Virtual Guide."}</p>
        {side}
      </div>
    );
  }
  return (
    <div className={`border-t ${t.footer}`}>
      <form onSubmit={(e) => { e.preventDefault(); onSend(); }} className="p-2.5 flex items-center gap-2">
        <input data-testid="vg-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder={inReview ? "Type your answer…" : cfg.input_placeholder || "Type your question…"} disabled={!me} className="flex-1 min-w-0 rounded-full border border-current/10 px-4 py-2.5 text-sm outline-none placeholder:opacity-50 disabled:opacity-60" style={{ background: t.input, color: t.inputText }} />
        {side}
        <button type="submit" data-testid="vg-send" disabled={busy || !input.trim() || !me} className="grid place-items-center w-10 h-10 rounded-full disabled:opacity-50 shrink-0" style={{ backgroundColor: t.accent, color: t.accentText }}><Send size={16} /></button>
      </form>
    </div>
  );
};
